var vueHttpSettings = {
    post: {emulateJSON: true}
};

var accessionaryFilters = new Vue({
    el: '#products-filters',
    data: {
        filters: {},
        showPreLoader: false,
        visibleItems: [],
    },
    created: function () {
        document.querySelectorAll('.filter-row').forEach((element, index) => {
            Vue.set(this.filters, element.dataset['group'], []);
        });
    },
    methods: {
        filterItems: function () {
            this.showPreLoader = true;

            var url = Routing.generate('accessionary.view.filter');
            var filters = document.getElementById('products-filters');
            console.log(filters.dataset);
            var data = {
                'filters': this.filters,
                'type': filters.dataset['type'],
                'sub_type': filters.dataset['subType'],
            };

            Vue.http.post(url, data, vueHttpSettings.post).then(
                (response) => {
                    document.getElementById('items-list').innerHTML = response.body.html;
                    this.showPreLoader = false;
                },
                (response) => {
                    this.showPreLoader = false;
                });
        }
    }
});